import { CoinbaseProfileMenuCommonHelpMenu } from '@cbhq/identity-api-hooks/profile-menu/types';

import { parseActions } from './parseAction';

export function parseHelpMenu(helpMenu: CoinbaseProfileMenuCommonHelpMenu) {
  const { title, subtitle, pictogram } = helpMenu;
  return {
    ...(title ? { title } : {}),
    ...(subtitle ? { subtitle } : {}),
    ...(pictogram ? { pictogram: pictogram as import('@cbhq/cds-common').PictogramName } : {}),
    actions: helpMenu?.actions?.map(parseActions) ?? [],
  };
}
